<nz-modal
    [(nzVisible)]="isVisible"
    [nzTitle]="modalTitle"
    (nzOnCancel)="close()"
    (nzOnOk)="save()"
    [nzOkLoading]="saving"
    [nzOkDisabled]="saving"
    [nzCancelDisabled]="saving"
    [nzMaskClosable]="!saving"
    [nzKeyboard]="!saving"
    [nzClosable]="!saving"
    nzOkText="Save"
    nzCancelText="Cancel"
    [nzWidth]="640">

    <ng-template #modalTitle>
        <span nz-icon nzType="safety-certificate" nzTheme="outline" style="margin-right: 8px;"></span>
        Permissions: {{ user?.name }} {{ user?.surname }}
        <span class="modal-subtitle">({{ user?.username }})</span>
    </ng-template>

    <ng-container *nzModalContent>
        <p class="permissions-intro">Enable or disable specific access permissions below.</p>

        @if (loading) {
            <div class="permissions-loading">
                <nz-spin nzSimple></nz-spin>
            </div>
        } @else {
            <div class="permissions-sections">
                @let type = PermissionTypeEnum.Gui;
                @let categories = getCategoriesByType(type);
                
                @if (categories.length > 0) {
                    <nz-card class="permission-card" [nzBordered]="true" nzSize="small">
                        <div class="card-header-row">
                            <span nz-icon nzType="desktop" nzTheme="outline" class="section-icon"></span>
                            <h4 class="section-title">System Permissions</h4>
                            <div class="section-actions">
                                <button nz-button nzType="link" nzSize="small" (click)="selectAllForType(type)">All</button>
                                <span class="action-divider">·</span>
                                <button nz-button nzType="link" nzSize="small" (click)="clearAllForType(type)">None</button>
                            </div>
                        </div>

                        <div class="category-container">
                            @for (cat of categories; track cat) {
                                <div class="category-group">
                                    <div class="category-header">
                                        <span class="category-name">{{ cat }}</span>
                                        <hr class="category-line" />
                                    </div>
                                    
                                    <ul class="permission-grid">
                                        @for (perm of getPermissionsByGroup(type, cat); track perm.id) {
                                            <li class="permission-item">
                                                <label nz-checkbox
                                                    [ngModel]="isChecked(perm)"
                                                    (ngModelChange)="toggle(perm)"
                                                    class="permission-checkbox">
                                                    <span class="perm-name">{{ perm.permission }}</span>
                                                </label>
                                                @if (perm.description) {
                                                    <span class="perm-info" nz-tooltip [nzTooltipTitle]="perm.description">
                                                        <span nz-icon nzType="info-circle" nzTheme="outline"></span>
                                                    </span>
                                                }
                                            </li>
                                        }
                                    </ul>
                                </div>
                            }
                        </div>
                    </nz-card>
                }
            </div>
        }
    </ng-container>

</nz-modal>